import React from "react";
import "./style.css";
import Icon from "../Icon";
import useReveal from "../../hooks/useReveal";

const LOGOS = [
  "BharatNova",
  "AaryaTech",
  "Yuganta Systems",
  "Trinetra Labs",
  "Vedastra",
  "AstraMind",
];

export default function TrustStrip() {
  const [rowRef, rowVisible] = useReveal();

  const trustItems = [
    { icon: "sparkles", accent: "indigo", label: "AI-First Engineering" },
    { icon: "shield", accent: "green", label: "Security by Default" },
    { icon: "cloud", accent: "blue", label: "Scalable Cloud Infrastructure" },
    { icon: "bolt", accent: "amber", label: "24/7 Dedicated Support" },
  ];

  return (
    <section className="trust-strip">
      <div className="container">
        {/* Row 1: Trust Statements */}
        <div className="trust-row-1" ref={rowRef}>
          <div className="row g-0 reveal-stagger">
            {trustItems.map((item, index) => (
              <div
                key={item.label}
                className={`col-6 col-md-3 trust-col reveal ${
                  rowVisible ? "" : "is-hidden"
                }`}
                style={{ "--stagger-index": index }}
              >
                <div className="trust-item icon-hover">
                  <div
                    className={`trust-icon-wrap trust-icon-wrap--${item.accent}`}
                  >
                    <Icon name={item.icon} size={26} className="trust-icon" />
                  </div>
                  <div className="trust-label">{item.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Row 2: Client Logos — infinite marquee */}
        <div className="trust-row-2">
          <div className="logos-label">Trusted by growing businesses</div>
          <div className="logos-marquee marquee">
            <div className="marquee__track">
              {/* Second copy is what makes the -50% loop seamless. It is
                  duplicate content, so keep it out of the a11y tree. */}
              {[0, 1].map((copy) => (
                <div className="logos-group" key={copy} aria-hidden={copy === 1}>
                  {LOGOS.map((name) => (
                    <div key={name} className="logo-placeholder">
                      {name}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
